import React, { useState, useRef } from "react";
import Fade from 'react-reveal/Fade';

export default function FeaturedImage({ data }) {
  const [mainImage, setMainImage] = useState(data[0]);
  const mainHeight = 500;

  return (
    <section className="container my-4">
      {/* Tampilan Desktop */}
      <div className="d-none d-md-block">
        <div className="row g-3">
          {/* Gambar utama kiri */}
          <div className="col-md-8">
            <Fade bottom>
              <div className="card border-0 shadow-sm overflow-hidden h-100">
                <figure
                  className="m-0"
                  style={{
                    height: `${mainHeight}px`,
                    borderRadius: "10px",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={`${process.env.REACT_APP_HOST}/images/${mainImage.imageUrl}`}
                    alt={mainImage._id}
                    className="w-100 h-100"
                    style={{
                      objectFit: "cover",
                      objectPosition: "center",
                      borderRadius: "10px",
                    }}
                  />
                </figure>
              </div>
            </Fade>
          </div>

          {/* Gambar-gambar kanan */}
          <div
            className="col-md-4"
            style={{
              height: `${mainHeight}px`,
              overflowY: data.length > 3 ? "auto" : "hidden",
              scrollbarWidth: "thin",
              paddingRight: "5px",
            }}
          >
            <div
              className="d-flex flex-column justify-content-start"
              style={{
                gap: "10px",
              }}
            >
              {data.map((item, index) => (
                <Fade bottom delay={100 * index} key={item._id}>
                  <div
                    className={`card border-0 shadow-sm overflow-hidden ${
                      mainImage._id === item._id
                        ? "border border-secondary"
                        : ""
                    }`}
                    style={{
                      cursor: "pointer",
                      borderRadius: "10px",
                      flex: "0 0 auto",
                      height: `${mainHeight / 3 - 10}px`, // bagi tinggi 3
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#f8f9fa",
                    }}
                    onClick={() => setMainImage(item)}
                  >
                    <figure
                      className="m-0 w-100 h-100"
                      style={{
                        overflow: "hidden",
                        borderRadius: "10px",
                      }}
                    >
                      <img
                        src={`${process.env.REACT_APP_HOST}/images/${item.imageUrl}`}
                        alt={item._id}
                        className="w-100 h-100"
                        style={{
                          objectFit: "cover",
                          objectPosition: "center",
                          borderRadius: "10px",
                        }}
                      />
                    </figure>
                  </div>
                </Fade>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Tampilan Mobile (Bootstrap Carousel, TANPA animasi Fade) */}
      <div className="d-block d-md-none">
        <div id="featuredImageCarousel" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-inner">
            {data.map((item, index) => (
              <div
                key={`carousel-${index}`}
                className={`carousel-item ${index === 0 ? 'active' : ''}`}
              >
                <div className="card border-0 shadow-sm overflow-hidden">
                  <figure className="img-wrapper m-0" style={{ height: "300px" }}>
                    <img
                      src={`${process.env.REACT_APP_HOST}/images/${item.imageUrl}`}
                      alt={item._id}
                      className="d-block w-100 h-100 object-fit-cover"
                    />
                  </figure>
                </div>
              </div>
            ))}
          </div>

          {/* Tombol navigasi carousel */}
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#featuredImageCarousel"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#featuredImageCarousel"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>

          {/* Indicator bulatan di bawah */}
          <div className="carousel-indicators">
            {data.map((_, index) => (
              <button
                key={`indicator-${index}`}
                type="button"
                data-bs-target="#featuredImageCarousel"
                data-bs-slide-to={index}
                className={index === 0 ? "active" : ""}
                aria-current={index === 0 ? "true" : "false"}
                aria-label={`Slide ${index + 1}`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
